function MarcasPrincipais() {
  return (
    <div className="MarcasPrincipais">
      <footer className="MarcasPrincipais-footer">
        <h3>Outras Marcas</h3>
        <ul className="mapaFooter">
          <li>Polly Pocket</li>
          <li>HotWheels</li>
          <li>Barbie</li>
        </ul>
      </footer>
    </div>
  );
}

export default MarcasPrincipais;
